import { Box, Typography } from '@mui/material'
import React from 'react'
import { InputLabelStyled } from '../../DiabeticForm/sub-form-sections/PresentingComplaintSection'
import CheckboxController from '../../../../components/CheckboxSelector/CheckboxSelector';
import { footwearFrequentOptions, footwearWornOftenOptions } from './formFootOptions';
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController';
import { CustomInputLable, InputContainer, ParentContainerSection } from '../FootForm';


const FootWearWorn = (props) => {
    const {control, errors, getValues} = props
  return (
  <ParentContainerSection heading="Section D - Assessment of footwear">
        <CustomInputLable required sx={{ marginBottom: "0.5rem"}}>Footwear most often wear</CustomInputLable>
        <InputContainer sx={{ marginLeft: "4px !important" }}>
     
<CheckboxController
            name={"footwear_often_worn.footwear_often_worn"}
            isRow={true}
            isMultiCheckbox={true}
            control={control}
            errors={errors}
            options={footwearWornOftenOptions}
            isDisabled={true}
            isHorizantalPadding={true}
            isCustomPadding
            size="small" />


        </InputContainer>

        <CustomInputLable required sx={{ marginBottom: "0.5rem"}}>Frequency of wearing footwear</CustomInputLable>
        <InputContainer    sx={{ marginLeft: "4px !important" }}>
          <RadioButtonController
            name="footwear_often_worn.frequency_footwear"
            control={control}
            errors={errors}
            options={footwearFrequentOptions}
            isRow
            isDisabled
          />
        </InputContainer>

      </ParentContainerSection>
  )
}

export default FootWearWorn